import { jsx as s, jsxs as a } from "react/jsx-runtime";
import { d as i, W as l, _ as m } from "../../vendor-CPVnY93G.js";
import { forwardRef as d } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as p } from "../../utils/omitStyleRenderProps/index.js";
import { TooltipTrigger as _, Tooltip as u } from "../Tooltip/index.js";
import '../../assets/index12.css';const k = "_link_11ndj_1", x = "_truncate_11ndj_10", $ = "_href_11ndj_28", t = {
  link: k,
  truncate: x,
  href: $
}, y = d(
  ({ children: o, truncate: r = !1, ...e }, c) => {
    const f = i(t.link, {
      [t.href]: !!e.href,
      [t.truncate]: r
    }), n = /* @__PURE__ */ s(
      l,
      {
        ...p(e),
        slot: null,
        ref: c,
        className: f,
        "data-component": "Link",
        children: o
      }
    );
    return r ? /* @__PURE__ */ a(_, { children: [
      n,
      /* @__PURE__ */ s(u, { children: typeof o != "function" ? o : void 0 })
    ] }) : n;
  }
), L = m;
export {
  y as Link,
  L as RouterProvider
};
